import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import { usePageContext } from "@/lib/brand";

export const TopBar = () => {
  const { brand } = usePageContext();
  return (
    <div className="bg-hv-topbar font-heading text-[12px] font-medium text-white" data-testid="utility-top-bar">
      <div className="mx-auto flex h-8 max-w-[1280px] items-center justify-between px-6">
        <nav aria-label="Brand switcher" className="flex items-center gap-2">
          <Link to="/" data-testid="topbar-harvest-etfs-link" className="text-hv-orange hover:underline">Harvest ETFs</Link>
          <span aria-hidden="true" className="text-white/60">|</span>
          <Link to="/high-income-shares/" data-testid="topbar-hhis-link" className="text-hv-blue hover:underline">Harvest High Income Shares</Link>
        </nav>
        <nav aria-label="Site language" className="flex items-center gap-2">
          <a href="#" data-testid="topbar-english-link" aria-current="true">English</a>
          <span aria-hidden="true" className="text-white/60">|</span>
          <a href="https://harvestportfolios.com/fr-CA/" data-testid="topbar-french-link" className="hover:text-hv-orange">French</a>
        </nav>
      </div>
    </div>
  );
};

const NAV = ["Products", "Insights", "Media", "Resources", "About"];

export const SiteHeader = () => {
  const { brand, theme } = usePageContext();
  const home = brand === "hhis" ? "/high-income-shares/" : "/";
  return (
    <header className="sticky top-0 z-30 border-b border-hv-rule bg-white" data-testid="site-header">
      <div className="mx-auto flex h-[76px] max-w-[1280px] items-center justify-between px-6">
        <Link to={home} data-testid="header-logo-link" aria-label={brand === "hhis" ? "Harvest High Income Shares home" : "Harvest ETFs home"}>
          <img src={theme.header_logo} alt={brand === "hhis" ? "Harvest High Income Shares" : "Harvest ETFs"} className="h-9 w-auto" />
        </Link>
        <nav aria-label="Main" className="hidden items-center gap-9 font-heading text-[14px] font-medium text-hv-text md:flex">
          {NAV.map((n) => (
            <a key={n} href="#" data-testid={`nav-${n.toLowerCase()}`} className="transition-colors hover:text-hv-logo-navy">{n}</a>
          ))}
          <button type="button" aria-label="Search" data-testid="nav-search-button" className="text-hv-text hover:text-hv-logo-navy">
            <Search size={18} strokeWidth={2} />
          </button>
        </nav>
      </div>
    </header>
  );
};
